import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Entity} from '../../../../../models/entity.model';
import {EntitiesTypes} from '../../../../../models/htmlDocument.model';

@Component({
  selector: 'app-entities-bar-row',
  templateUrl: './entities-bar-row.component.html',
  styleUrls: ['./entities-bar-row.component.scss']
})
export class EntitiesBarRowComponent implements OnInit {
  @Input() entities: Entity[];
  @Input() label: EntitiesTypes;
  @Output() deleteEntity: EventEmitter<Entity> = new EventEmitter();

  firstRowClass: string;
  constructor() { }

  ngOnInit(): void {
    // console.log(this.entities);
  }

  delete(entity): void {
    // console.log(entity);
    this.deleteEntity.emit(entity);
    const index = this.entities.indexOf(entity, 0);
    if (index > -1) {
      this.entities.splice(index, 1);
    }
  }

}
